//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../AME/AME.EngineeringObjectAspectDetailBuilder.js";
import "../AME/AME.SelectAMEBaseNodeList.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"EngObjDescription",1,0],[0,"EngObjName",1,0],[1,"ListAspectDetail",0,"AME.EngineeringObjectAspectDetailBuilder",0],[1,"SelectedPlcBaseSymbols",0,"AME.SelectAMEBaseNodeList",0],[1,"SelectionParent",0,"SelectNXObject",0]],[[["engObject"],"SetEngobjectsToEdit",{},1,0],[["roots","states"],"SetAspectStates",{},2,0]],[]];
SPLM.AME.EditEngineeringObjectBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.EditEngineeringObjectBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.EditEngineeringObjectBuilder.SourceType = Object.freeze({
    "AssignEos" : "AssignEos", "AssignPous" : "AssignPous"});

export default SPLM;